import { render, staticRenderFns } from "./PerformanceDashboard.vue?vue&type=template&id=9dd619a4&scoped=true"
import script from "./PerformanceDashboard.vue?vue&type=script&lang=js"
export * from "./PerformanceDashboard.vue?vue&type=script&lang=js"
import style0 from "./PerformanceDashboard.vue?vue&type=style&index=0&id=9dd619a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd619a4",
  null
  
)

export default component.exports